import React, { useState } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme=>({
  root: {
    width: '15px',
    height: '100%',
    backgroundColor: '#fff',
    cursor: 'ew-resize',
    display: 'flex',
    alignItems: 'center',
  },
  draggerBox: { 
    backgroundColor: theme.palette.primary['clr-100'],
    color: theme.palette.primary.main,
    width: '15px', height: '25px',
    fontSize: '12px',
    fontWeight: 'bold',
    padding: '5px',
    display: 'flex', 
    alignItems: 'center',
    justifyContent: 'center',
  }
}));

const SectionSlider = ({ setLeftWidth, setDraggingStart=()=>{} }) => {
  const classes = useStyles();
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setDraggingStart(true);
  };
  
  const handleMouseUp = () => {
    setIsDragging(false);
    setDraggingStart(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const newWidth = (e.clientX / window.innerWidth) * 100;
    if (newWidth > 30 && newWidth < 70) {
      setLeftWidth(newWidth);
    }
  };

  React.useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    } else {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    }
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  return (
      <Box className={classes.root} onMouseDown={handleMouseDown}>
        <Box className={classes.draggerBox}>=</Box>
      </Box>
  );
};

export default SectionSlider;
